<template>
    <div class="test-view">
        <v-card class="mx-auto normal-card instructions-hg cat-5" v-if="isOnline">
            <div class="summary-title">Exam Summary</div>
            <div class="summary-table">
                <v-simple-table fixed-header class="summary-tab-20">
                    <template v-slot:default>
                        <thead>
                            <tr>
                                <th class="text-center">Section Name</th>
                                <th class="text-center">Number of Questions</th>
                                <th class="text-center">Answered</th>
                                <th class="text-center">Not Answered</th>
                                <th class="text-center">Not Visited</th>
                                <th class="text-center">Marked for Review</th>
                                <th class="text-center">
                                    <div class="last-col-center">
                                        Answered and
                                        <br />Marked for Review
                                        <div
                                            class="considered_red"
                                        >(Will be considered for evaluation)</div>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in legendsData" :key="item.name">
                                <td class="text-center">{{ item.name }}</td>
                                <td class="text-center">{{ item.questions }}</td>
                                <td class="text-center">{{ item.answered }}</td>
                                <td class="text-center">{{ item.notAnswered }}</td>
                                <td class="text-center">{{ item.notVisited }}</td>
                                <td class="text-center">{{ item.reviewLater }}</td>
                                <td class="text-center">{{ item.answeredReviewLater }}</td>
                            </tr>
                        </tbody>
                    </template>
                </v-simple-table>
            </div>
            <div
                class="want-to-finish"
            >Are you sure you want to finish the test and submit your responses for evaluation</div>
            <div class="two-btn">
                <v-btn color="primary" class="cust-btn" @click="finishTest()">Yes</v-btn>
                <v-btn color="primary" :disabled="isTimeUp" class="cust-btn" @click="goBack()">No</v-btn>
            </div>
        </v-card>
        <div class="no-internet" v-else>
            <h4>Please check your internet connection. Reload the page or wait on this screen till internet is back.</h4>
        </div>

        <div class="test-bottom">
            <div class="bottom-logo">
                <!-- <img src="/img/logo-footer.c1b83f14.png" class="master-logo-btm" /> -->
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
import momentDuration from "moment-duration-format";
momentDuration(moment);

export default {
    name: "TestDashboard",
    data() {
        return {
            legendsData: [],
            testData: {},
            heartBeatInterval: null,
            timeRemainingInterval: null,
            isOnline: true,
            isTimeUp: false,
            timeObj: null,
            endTest:true
        };
    },
    beforeDestroy() {
        this.setIsTestStarted(false);
        this.clearAllIntervals();
        let scrollElem = document.getElementsByClassName("v-application--wrap");
        scrollElem[0].scrollIntoView();
    },
    mounted() {
        this.setIsTestStarted(true);
        let testData = sessionStorage.getItem("testData");
        let timeObj = sessionStorage.getItem("timeObj");
        this.testData = JSON.parse(testData);
        this.timeObj = JSON.parse(timeObj);
        this.isTimeUp = this.testData.isTimeUp;
        this.legendsData = this.testData.legends;

        if (this.isTimeUp) {
            this.updateProgress();
        } else {
            this.startTimers();
        }
        this.setSelectedSQTIndex(0);
    },
    computed: {
        ...mapState("userStore", ["user", "pendingTestList"]),
    },
    methods: {
        ...mapActions({
            updateProgressInDB: "testStore/updateProgressInDB",
            setIsTestStarted: "testStore/setIsTestStarted",
            setPendingTestList: "userStore/setPendingTestList",
            updateHeartBeat: "testStore/updateHeartBeat",
            setSelectedSQTIndex: "testStore/setSelectedSQTIndex",
        }),
        redirectAsType() {
            if(this.endTest){
              this.endTest=false;
              this.$root.showLoader = true;
              let route =this.user.role_id === this.roleIds.ST?"live-test":"schedule-tests";
      		  let previousRoute = localStorage.getItem("previousRoute");
			  if (previousRoute==='make-your-test') {
			  	route=previousRoute
			  }else if(previousRoute==='ready-made-test'){
				route=previousRoute
			  }
              switch (this.testData.testType) {
                  case this.TEST_TYPE.PREVIOUS_YEAR:
                     route = "premium-test";
                      break;
                  case this.TEST_TYPE.CUSTOM:
                      route = this.user.role_id === this.roleIds.ST?"live-test":"schedule-tests";
                      break;
              }
              let routeInfo = sessionStorage.getItem( "routeInfo");
              routeInfo = JSON.parse(routeInfo);
		      localStorage.removeItem("previousRoute");
              routeInfo.testFinished = true;
              sessionStorage.setItem("routeInfo", JSON.stringify(routeInfo));
              this.removeCookie();
              this.setPendingTestList(null);
              this.$router.push({ name: route});
            }
        },
        removeCookie() {
            let currentTestCookieExists = this.$cookies.isKey("CATAPULT_TEST");
            if (currentTestCookieExists) {
                this.$cookies.remove("CATAPULT_TEST");
            }
        },
        disableNavigation() {
            history.pushState(null, null, document.URL);
            window.addEventListener("popstate", function () {
                history.pushState(null, null, document.URL);
            });
        },
        startTimers() {
            this.startHeartBeatTimer();
            this.startTimer(this.timeObj);
        },
        startTimer(durationString) {
            let timeObj = moment.duration(durationString);

            this.timeRemainingInterval = setInterval(() => {
                if (this.isOnline) {
                    timeObj.subtract(1, "seconds");
                    sessionStorage.setItem("timeObj", JSON.stringify(timeObj));

                    if (
                        timeObj.hours() < 1 &&
                        timeObj.minutes() < 1 &&
                        timeObj.seconds() < 1
                    ) {
                        this.isTimeUp = true;
                        this.updateProgress();
                        this.clearAllIntervals();
                    }
                }
            }, 1000);
        },
        startHeartBeatTimer() {
            this.heartBeat();
            this.heartBeatInterval = setInterval(() => {
                this.heartBeat();
            }, this.HEART_BEAT_TIME);
        },
        heartBeat() {
            var postData = {
                test_institute_id: this.testData.instituteId,
                test_schedule_id: this.testData.testScheduleId,
                question_id: this.testData.questionId,
                test_detail_id: this.testData.testDetailId,
            };
            this.updateHeartBeat(postData)
                .then((res) => {
                    this.isOnline = true;
                })
                .catch((err) => {
                    this.isOnline = false;
                });
        },
        clearAllIntervals() {
            clearInterval(this.timeRemainingInterval);
            clearInterval(this.heartBeatInterval);
        },
        
        finishTest() {
            let test = localStorage.getItem("previousRoute");
            test = test == "ready-made-test" ? "Ready-made Tests" : test == "make-your-test"? "Self-made Tests" : this.testData.testType == this.TEST_TYPE.MYT;
            if(test) {
            this.$toasted.success(`The result for this test will be ready in 2 minutes and can be seen in Test Results by selecting ${test}`, {});
            }
            this.setIsTestStarted(false);
            sessionStorage.removeItem("testData");
            sessionStorage.removeItem("timeObj");
            this.updatePendingList();
            if (!this.isTimeUp) {
                this.updateProgress();
            } else {
                this.redirectAsType();
            }
        },
        goBack() {
            let previousRoute = localStorage.getItem("previousPath");
            const elem = document.documentElement; // Get the root element of the document
            if (elem.requestFullscreen) {
                elem.requestFullscreen();
            } else if (elem.mozRequestFullScreen) {
                elem.mozRequestFullScreen();
            } else if (elem.webkitRequestFullscreen) {
                elem.webkitRequestFullscreen();
            } else if (elem.msRequestFullscreen) {
                elem.msRequestFullscreen();
            } else if (elem.webkitEnterFullscreen) {
                elem.webkitEnterFullscreen(); // For iOS Safari
            } else if (elem.webkitEnterFullScreen) {
                elem.webkitEnterFullScreen(); // For older versions of iOS Safari
            }               
            this.$router.push(previousRoute);            
        },
        updateProgress() {
            let data = [
                {
                    activity: this.QUESTION_ACTIVITY.STOP,
                    entity: this.QUESTION_ENTITY.TEST,
                    entity_id: this.testData.testId,
                    isAutoFinished: this.testData.isAutoFinished
                },
            ];
            var postData = {
                test_institute_id: this.testData.instituteId,
                test_schedule_id: this.testData.testScheduleId,
                actions: data,
            };
            this.$root.showLoader = true;
            this.updateProgressInDB(postData)
                .then((response) => {
                    if (!this.isTimeUp) {
                        // this.$router.push({ name: "schedule-tests" });
                        sessionStorage.removeItem('changedTab')
                    } else {
                        this.$root.showLoader = false;
                    }
                    this.redirectAsType();
                })
                .catch((e) => {
                    console.log("updateProgressInDB: failed = ", e);
                    this.$root.showLoader = false;
                    // this.redirectAsType();                    
                });
        },
        updatePendingList() {
            let pendingTestList = this.pendingTestList;
            if (pendingTestList && pendingTestList.length > 0) {
                pendingTestList.shift();
                this.setPendingTestList(pendingTestList);
            }
        },
    },
};
</script>
